
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";

const ActivityHoverContent = ({ material, config = {} }) => {
  const {
    showDescription = true,
    showCompletion = true,
    showPeerParticipation = false,
    showDifficulty = false,
  } = config;

  let data = material.datajson;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      data = null;
    }
  }
  const description = data?.description ?? material.description;

  return (
    <div className="w-[250px] text-left text-gray-800">
      <div className="font-semibold text-sm leading-5">
        {material.activitytitle}
      </div>

      {showDescription && description && (
        <div className="text-xs text-gray-600 mt-1 leading-4">
          {description}
        </div>
      )}

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-xs">
        {showCompletion && (
          <span className="flex items-center gap-1">
            {material.completed ? (
              <BsCheckCircleFill className="text-green-600" />
            ) : (
              <BsCircle className="text-gray-400" />
            )}
            {material.completed ? "Completed" : "Not completed"}
          </span>
        )}

        {showPeerParticipation &&
          material.peerParticipation != null && (
            <span>
              {Math.round(material.peerParticipation)}% tried
            </span>
          )}

        {showDifficulty && material.difficulty && (
          <span>{material.difficulty}</span>
        )}
      </div>
    </div>
  );
};

export default ActivityHoverContent;
